var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBymBiolgiskMangfold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.964 32H17v-1.964A6.036 6.036 0 0123.036 24H25v1.964A6.04 6.04 0 0118.964 32zM13.036 32H15v-1.964A6.036 6.036 0 008.964 24H7v1.964A6.04 6.04 0 0013.036 32z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-180 14 11.5)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 13,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 13,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 3
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    d: "M16 21v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymBiolgiskMangfold);
export default __webpack_public_path__ + "static/media/BYM_BiolgiskMangfold.03e9bfe1.svg";
export { ForwardRef as ReactComponent };